var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 67,
    viewBox: "0 0 105 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 67,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "About me",
    clipPath: "url(#clip0_1503_98)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4605,
    transform: "translate(-220 -2361)",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -139.5,
    y: -72.5,
    width: 634,
    height: 348,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -139.5,
    y: -72.5,
    width: 634,
    height: 348,
    stroke: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.2892 41.7218H46.801L32.317 0L0 66.1968C35.5542 51.7127 69.4061 47.6103 100.886 57.8803C62.0385 42.866 37.7868 46.9405 15.3771 53.443L30.782 21.3493L38.2892 41.7218Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.3076 31.4238L23.2749 45.3218C26.7913 43.3403 30.4751 42.2799 35.024 44.345L30.3076 31.4238Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.1663 16.5495L53.5803 18.6426H51.6826L54.1663 10.5215H56.5664L59.0781 18.6426H57.0966L56.4827 16.5495H54.1663ZM56.2315 15.1541L55.7292 13.4239C55.5896 12.9494 55.4501 12.3355 55.3105 11.861H55.2826C55.171 12.3355 55.0315 12.9494 54.9198 13.4239L54.4454 15.1541H56.2315Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.1666 10.6057C60.8364 10.4941 61.7295 10.4382 62.6504 10.4382C64.1853 10.4382 65.19 10.7173 65.9714 11.3034C66.8086 11.9173 67.3389 12.922 67.3389 14.3732C67.3389 15.936 66.7807 16.9965 65.9993 17.6663C65.1342 18.364 63.8504 18.7268 62.2597 18.7268C61.3108 18.7268 60.6411 18.671 60.1666 18.6152V10.6057ZM62.0085 17.2477C62.176 17.2756 62.4271 17.2756 62.6504 17.2756C64.3249 17.2756 65.4132 16.3826 65.4132 14.429C65.4132 12.7546 64.4365 11.8615 62.8457 11.8615C62.4271 11.8615 62.176 11.8894 62.0085 11.9452V17.2477V17.2477Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70.4097 18.6152L67.8143 10.4941H69.8236L70.8004 13.9267C71.0795 14.9035 71.3307 15.8244 71.526 16.8291H71.5539C71.7493 15.8523 72.0004 14.8756 72.2795 13.9546L73.3121 10.4941H75.2656L72.5307 18.6152H70.4097Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M77.385 16.5496L76.7989 18.6426H74.9012L77.385 10.5215H79.785L82.2967 18.6426H80.3153L79.7013 16.5496H77.385ZM79.4501 15.1542L78.9478 13.4239C78.8082 12.9495 78.6687 12.3355 78.5292 11.8611H78.5013C78.3896 12.3355 78.2501 12.9495 78.1385 13.4239L77.664 15.1542H79.4501Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M83.4137 18.6152V10.4941H85.5626L87.237 13.4802C87.7114 14.3453 88.2138 15.35 88.5766 16.2709H88.6045C88.4929 15.2104 88.437 14.0941 88.437 12.8941V10.522H90.1115V18.6431H88.2138L86.4835 15.5174C86.0091 14.6523 85.4788 13.5918 85.0602 12.6429H85.0323C85.0881 13.7034 85.116 14.8476 85.116 16.1872V18.6431H83.4137V18.6152Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M97.7042 18.3923C97.3693 18.5598 96.6158 18.7551 95.6112 18.7551C92.7925 18.7551 91.3413 16.9969 91.3413 14.6806C91.3413 11.9178 93.3227 10.3549 95.7786 10.3549C96.7275 10.3549 97.4531 10.5503 97.788 10.7177L97.4252 12.1689C97.0624 12.0015 96.5321 11.8619 95.8902 11.8619C94.439 11.8619 93.2948 12.755 93.2948 14.5411C93.2948 16.1597 94.2716 17.1923 95.8902 17.1923C96.4484 17.1923 97.0624 17.0807 97.4252 16.9132L97.7042 18.3923Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M103.731 15.1825H100.745V17.1082H104.094V18.6152H98.9031V10.4941H103.926V12.0011H100.745V13.6755H103.731V15.1825Z",
    fill: "#6C757D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M61.1728 38.5956H54.5029L53.3865 41.8608H48.8376L55.368 24.1674H60.3355L66.8659 41.8608H62.2612L61.1728 38.5956ZM60.0564 35.3025L57.8518 28.7442L55.6192 35.3025H60.0564Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M88.5776 24.1382V41.8316H84.2798V30.7523L80.4565 41.8316H76.7169L72.8656 30.7523V41.8316H68.5678V24.1382H73.8424L78.6704 36.4733L83.3868 24.1382H88.5776Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M96.0022 38.3714H103.872V41.8599H91.23V38.5947L98.9604 27.5154H91.3138V24.0548H103.816V27.32L96.0022 38.3714Z",
    fill: "#ADB5BD"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1503_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4605,
    fill: "white",
    transform: "translate(-220 -2361)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group (1).11c3617bc77d556538f025c95b5da663.svg";
export { ForwardRef as ReactComponent };